import EditProfile from "./EditProfile";

export const routes = [
    {
        path: "/edit-profile",
        component: EditProfile,
        exact: true,
        showNav: true
    }
]